<template>
    <div class="next inviteExchange">
        <div class="title">
            <span> {{$t('my.proxy.agentExchange')}} </span>
            <div class="fixed" @click="goOtherPage('/mine/myProxy')">
                <svg t="1658129167849" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12456" width="0.3rem" height="0.3rem"><path d="M245.01248 555.52512l447.0784 447.0784c22.42048 22.42048 58.81856 22.42048 81.31584 0 22.42048-22.42048 22.42048-58.81856 0-81.31584l-406.49216-406.4256 406.49728-406.49216c22.42048-22.42048 22.42048-58.81856 0-81.31584-22.42048-22.42048-58.81856-22.42048-81.31584 0L244.9408 474.20928c-22.43584 22.47168-22.40512 58.88 0.07168 81.31584 0-0.00512 0 0 0 0z" fill="#666666" p-id="12457"></path></svg>
            </div>
            <div @click="goOtherPage('/mine/myProxy/record/exchange')" class="title_ellipsis">
                {{$t('my.invite.exchangeRecord')}}
            </div>
        </div>

        <div class="rechargeItem">
            <h2>{{$t('my.invite.enterExchangeAount')}}（{{$t('my.finance.currency')}}）</h2>
            <div class="flexBetween">
                <van-field v-model.trim="money" @keyup="money=money.replace(/[^\d]/g,'')" autocomplete="off" clearable :placeholder="`${$t('my.invite.enterExchangeAount')}`"/>
                <div @click="allMoeny" style="width: 2rem;text-align: right;padding-right: 0.28rem;">{{$t('common.fullAmount')}}</div>
            </div>
            <div class="padDoule"> {{$t('my.proxy.currentCommission')}}：<span>{{numFormat(digitalNumber(detailData.totalCommission))}} {{$t('my.finance.currency')}}</span></div>

            <div v-show="!money || money <= 0 || parseFloat(money) > detailData.totalCommission" class="confirmBtn">{{$t('common.submit')}}</div>
            <div v-show="money && money > 0 && parseFloat(money) <= detailData.totalCommission" class="confirmBtn hasValue" @click="userExchange">{{$t('common.submit')}}</div>
        </div>
    </div>
</template>

<script>
import { proxyWithdraw } from "@/api/proxy";
// import utils from "@/utils/index";
export default {
    data() {
        return {
            money: ""
        }
    },
    computed: {
        detailData() {
            return this.$store.state.detailData;
        },
        member() {
            return this.$store.state.member;
        },
    },
    methods: {
        // 全部金额
        allMoeny() {
            this.money = this.detailData.totalCommission ? Math.floor(this.detailData.totalCommission): 0;
        },
        goOtherPage(path) {
            this.$router.push(path);
        },
        // 兑换金币
        userExchange() {
            let params = {
                uid: this.member.uid,
                withdrawType: 1,
                goldCoin: this.money
            }
            proxyWithdraw(params).then(res => {
                if (res.code == 0) {
                    this.$toast(this.$t('common.submitSuccess'));
                    this.$router.push('/mine/myProxy/record/exchange')
                } else {
                    if (res.msg) this.$toast(res.msg);
                }
            }).catch(() => {
                console.log('catch');
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.inviteExchange {
    padding-top: 0.88rem;

    .title .title_ellipsis {
        font-size: 0.28rem;
        color: #626872;
    }

    .rechargeItem {
        width: 100%;
        background: #fff;
        text-align: left;
        padding: 0.2rem 0;

        h2 {
            height: 0.8rem;
            line-height: .8rem;
            font-size: .28rem;
            color: #414655;
            font-weight: 700;
            margin-left: 0.28rem;
            width: calc(100% - 0.28rem);

            span {
                font-size: 0.27rem;
                color: #C41F1A;
                margin-right: 0.1rem;
            }
        }

        .padDoule {
            padding: 0.2rem 0.28rem;
            color: #626872;

            span {
                color: #eb457e;
            }
        }

        .confirmBtn {
            margin: 0.21rem auto 0;
        }
    }
}
</style>